import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Top from '../pages/Top.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Top',
    component: Top
  },
  {
    path: '/delete-expired-room',
    name: 'DeleteExpiredRoom',
    component: () => import('../pages/DeleteExpiredRoom.vue')
  },
  {
    path: '/:id/student',
    name: 'student',
    component: () => import('../pages/Student.vue')
  },
  {
    path: '/:id/admin',
    name: 'admin',
    component: () => import('../pages/Admin.vue')
  }
];

export const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  // history: createWebHistory(process.env.BASE_URL),
  routes
});
